module.exports = __webpack_public_path__ + "img/example-cafeteria-menu-2-fr.b69541c5.jpg";